import { TransferReadingsInvoiceLineItem } from "@inrange/building-manager-api-client";
import { formatCurrency } from "@inrange/theme-components/formatting";
import { Button, Modal, Table } from "react-bootstrap";

const AxpoInvoiceModal = ({
  month,
  invoiceDate,
  lineItems,
  currencyCode,
  vatRate,
  onClose,
}: {
  month: string;
  invoiceDate: string | null;
  lineItems: TransferReadingsInvoiceLineItem[];
  currencyCode: string;
  vatRate: number;
  onClose: () => void;
}) => {
  const subtotal = lineItems.reduce((sum, item) => sum + item.amount, 0);
  const vat = subtotal * vatRate;
  const total = subtotal + vat;

  // Group line items by type
  const grouped: { type: string; items: TransferReadingsInvoiceLineItem[] }[] =
    [];
  let currentType: string | null = null;
  for (const item of lineItems) {
    if (item.type !== currentType) {
      currentType = item.type;
      grouped.push({ type: item.type, items: [] });
    }
    grouped[grouped.length - 1].items.push(item);
  }

  return (
    <Modal show={true} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Supplier Invoice Details — {month}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {invoiceDate && (
          <div className="mb-3" style={{ color: "#666" }}>
            Invoice date: {invoiceDate}
          </div>
        )}
        {lineItems.length === 0 ? (
          <div style={{ color: "#666" }}>
            No invoice line items found for {month}
          </div>
        ) : (
          <>
            <Table bordered size="sm" responsive>
              <thead>
                <tr style={{ backgroundColor: "#f8f9fa" }}>
                  <th>Type</th>
                  <th>Particulars</th>
                  <th className="text-end">Unit Price</th>
                  <th className="text-end">Volume</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {grouped.map((group) =>
                  group.items.map((item, idx) => (
                    <tr key={`${group.type}-${idx}`}>
                      {idx === 0 ? (
                        <td
                          rowSpan={group.items.length}
                          style={{
                            verticalAlign: "middle",
                            fontWeight: "600",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          {group.type}
                        </td>
                      ) : null}
                      <td>{item.subType}</td>
                      <td className="text-end">
                        {item.unitPrice !== 0
                          ? formatCurrency(item.unitPrice, currencyCode, 2)
                          : "—"}
                      </td>
                      <td className="text-end">
                        {item.volume !== 0
                          ? item.volume.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                          : "—"}
                      </td>
                      <td className="text-end">
                        {formatCurrency(item.amount, currencyCode, 2)}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr style={{ borderTop: "2px solid #dee2e6" }}>
                  <td colSpan={4} className="text-end">
                    <strong>Subtotal (excl. VAT)</strong>
                  </td>
                  <td className="text-end">
                    <strong>
                      {formatCurrency(subtotal, currencyCode, 2)}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4} className="text-end">
                    VAT @ {(vatRate * 100).toFixed(0)}%
                  </td>
                  <td className="text-end">
                    {formatCurrency(vat, currencyCode, 2)}
                  </td>
                </tr>
                <tr style={{ borderTop: "2px solid #dee2e6" }}>
                  <td colSpan={4} className="text-end">
                    <strong>Total Amount</strong>
                  </td>
                  <td className="text-end">
                    <strong>
                      {formatCurrency(total, currencyCode, 2)}
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AxpoInvoiceModal;
